import React from "react"
import EmptyState from "./EmptyState"

const ContractorEmptyState: React.FC = () => {
  const icon = (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 12l2 2 4-4" />
      <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z" />
      <path d="M12 2a10 10 0 0 1 10 10" />
    </svg>
  )

  return (
    <EmptyState
      title="No hay órdenes disponibles"
      message="No se encontraron órdenes que coincidan con los filtros seleccionados. Intenta ajustar los criterios de búsqueda o el rango de fechas."
      icon={icon}
    />
  )
}

export default ContractorEmptyState
